module.exports = __webpack_public_path__ + "static/media/warning-exclaimation.e0ca6ab5.svg";